module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-03-1bcbdc7322924a4ce2991cc5fc51841c.jpg";